module.exports = __webpack_public_path__ + "img/bg_rc.1775439203884.png";